



















































































import SimpleMap from '../../core/components/SimpleMap.vue';
import ModalForcePeriod from './ModalForcePeriod.vue';
import ForcePeriodSowingPatch from './ForcePeriodSowingPatch.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalCompanyHarvest from './ModalCompanyHarvest.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { dateFormat } from 'highcharts';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        ModalForcePeriod,
        ForcePeriodSowingPatch,
        DeleteConfirmation
    }
})
export default class ForcePeriodsSowing extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    overlappedPeriods: Array<object> = [];

    @Prop({
        default() {
            return [];
        }
    })
    forcedPeriods: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    vehiclesOptions: Array<object>;
    @Prop() vehicleID: number | null;
    @Prop({default(){return []}}) selectedWorkSegments: Array<object>;
    patchData: object | null = null;
    forcedPeriodPatch: object | null = null;
    forcedPeriodToAdd: object | null = null;
    visibleModalIgnorePeriod: boolean = false;
    visibleModalIgnorePeriodPatch: boolean = false;
    periodToDelete: object | null = null;

    @Emit()
    viewAllIgnoredPeriods() {}

    @Emit()
    getRanchDetail() {}

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    // @Emit()
    // reloadModalViewAll(){}

    get getHeaders() {
        let tableHeaders: Array<object> = [
            {
                text: 'Fecha Inicio',
                value: 'start_date',
                formatter: this.dateFormatter,
                sortable: true,
                width: '230px'
            },
            {
                text: 'Fecha Fin',
                value: 'end_date',
                formatter: this.dateFormatter,
                sortable: true,
                width: '230px'
            },
            {
                text: 'Es Trabajo',
                value: 'is_work',
                formatter: this.boolFormat,
                sortable: true,
                align: 'center'
            },
            {
                text: 'Acciones',
                value: 'actions',
                sortable: true,
                width: '100px'
            }
        ];

        if (this.vehicleID == -1) {
            tableHeaders.unshift({
                text: 'Vehículo',
                value: 'vehicle',
                align: 'center',
                sortable: true
            });
        }

        return tableHeaders;
    }

    addNewPeriodOverlapped(overlappedPeriods, newPeriod){
        newPeriod['force_overlapped'] = true;
        this.forcedPeriodToAdd = newPeriod;
        this.visibilityModalIgnorePeriodPatch(false);
        this.showOverlappedPeriods(overlappedPeriods);
    }
    openModalOverlapWithSegment(overlappedPeriods, currentPeriod){
        this.forcedPeriodPatch = currentPeriod;
        this.visibilityModalIgnorePeriodPatch(false);
        this.showOverlappedPeriods(overlappedPeriods);
    }

    showOverlappedPeriods(overlappedPeriods){
        //cierro modal periodos forzados
        this.visibilityModalIgnorePeriod(false);
        
        
        setTimeout(() => {
            //cierro loading dialog
            this.$_showLoadingDialog('');
            
            //abro de nuevo el modalForcePeriod pero con los periodos solapados
            this.overlappedPeriods = overlappedPeriods;
            this.visibilityModalIgnorePeriod(true);
            // console.log("mostrar periodos solapados", overlappedPeriods)
         }, 0)
    }

    editSelectedPeriod(item) {
        this.forcedPeriodToAdd = null;
        this.forcedPeriodPatch = null;
        this.patchData = item;
        this.overlappedPeriods = [];
        this.visibilityModalIgnorePeriodPatch(true);
    }

    deleteSelectedPeriod(item) {
        this.periodToDelete = item;

        this.showDeleteConfirmationDialog('Eliminar período ignorado', '¿Está seguro que desea eliminar este período');
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.deletePeriod();
        } else {
            this.confirmationDelete = false;
        }
    }

    deletePeriod() {
        let self = this;
        if (this.periodToDelete !== null) {
            this.loadingIgnoredPeriods = true;
            InsuranceServices.deleteIgnorePeriodSowing(this.periodToDelete['id'])
                .then(response => {
                    let msg = '';
                    if (response && response.data && response.data.message) {
                        msg = response.data.message;
                    } else {
                        msg = 'Período Eliminado con éxito';
                    }
                    this.loadingIgnoredPeriods = false;
                    this.$_successDeleteRecipients(msg);
                    this.forcedPeriods = removeItemsFromList(self.forcedPeriods, [self.periodToDelete], 'id');
                    // this.reloadModalViewAll();
                })
                .catch(error => {
                    this.loadingIgnoredPeriods = false;
                    this.showMsgError(error);
                });
        }
    }

    showMsgError(error) {
        let self = this;
        let msg = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
        } else {
            msg = 'Ocurrió un error';
        }
        this.$_errorAddFilter(msg);
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    boolFormat(value) {
        return booleanFormatter(value);
    }
    dateFormatter(value) {
        return formattedDate(value);
    }

    visibilityModalIgnorePeriod(value) {
        this.visibleModalIgnorePeriod = value;
    }
    visibilityModalIgnorePeriodPatch(value) {
        this.visibleModalIgnorePeriodPatch = value;
    }

    closeModalIgnorePeriod() {
        this.patchData = null;
        this.periodToDelete = null;
        this.visibilityModalIgnorePeriod(false);
    }
    closeModalIgnorePeriodPatch() {
        this.patchData = null;
        this.periodToDelete = null;
        this.visibilityModalIgnorePeriodPatch(false);
    }

    clickAddNewForcePeriod() {
        this.forcedPeriodToAdd = null;
        this.forcedPeriodPatch = null;
        this.patchData = null;
        this.periodToDelete = null;
        this.overlappedPeriods = [];
        this.visibilityModalIgnorePeriod(true);
    }

    addNewErrorLapsesToList(newPeriods) {
        this.forcedPeriods = [
            ...this.forcedPeriods,
            ...newPeriods
        ]
    }

    updateIgnoredPeriodInList(updatedPeriod) {
        let indexToUpdate = matchedIndexIdInArray(this.forcedPeriods, updatedPeriod['id']);
        if (indexToUpdate !== -1) {
            this.$set(this.forcedPeriods[indexToUpdate], 'end_date', updatedPeriod['end_date']);
            this.$set(this.forcedPeriods[indexToUpdate], 'start_date', updatedPeriod['start_date']);
            this.$set(this.forcedPeriods[indexToUpdate], 'is_work', updatedPeriod['is_work']);
        }
    }

    @Emit()
    refreshAnalyticView(){}
}
